<template>
<div class="list">
    <Header @gotoSearch="gotoSearch" @gotoAISearch="gotoAISearch"></Header>
    <div :class="{
        'list-content': true,
        'list-content-scroll': headerTitle == 3,
      }">
      <div v-if="headerTitle != 3 && headerTitle != 5" class="toolbar">
        <CreatePopper @refresh="refresh" @handleCreate="handleCreate"></CreatePopper>
        <UploadPopper @refresh="refresh" @handleUpload="handleUpload"></UploadPopper>
        <TemplateEntrance @gotoTemplateLib="gotoTemplateLib"></TemplateEntrance>
      </div>
      <div v-if="headerTitle == 1" class="tab-title">{{ tabTitle }}</div>
      <div v-if="headerTitle == 3" class="tab-title">{{$t("置顶知识库#!!!#src/pages/CloudHome/components/List.vue_1")}}</div>
      <StarList v-if="headerTitle == 3" @handleOpenWiki="handleOpenWiki"></StarList>
      <div v-if="headerTitle == 3" class="tab-title">{{$t("全部知识库#!!!#src/pages/CloudHome/components/List.vue_1")}}</div>
      <div :class="tableClass">
        <!-- 首页 -->
        <moo-table @row-click="handleClick" v-if="headerTitle == 1" :data="listData" style="width: 100%" height="100%">
          <moo-table-column prop="contentType" :label="$t('类型#!!!#src/pages/CloudHome/components/List.vue_1')" width="70">
            <template slot-scope="scope">
              <svg-icon :iconClass="fileAvatar(scope.row)" class="file-icon" v-show="showSvgIcon(scope.row)"></svg-icon>
              <div class="file-icon" v-show="!showSvgIcon(scope.row)" v-if="isPicture(scope.row.fileName)">
                <img class="file-image" @error="onImageError(scope.row)" @load="onImageLoad(scope.row)" :src="imgSrc(scope.row.fileId)">
              </div>
            </template>
          </moo-table-column>
          <moo-table-column show-overflow-tooltip="" prop="fileName" :label="$t('名称#!!!#src/pages/CloudHome/components/List.vue_1')" width="calc(100% - 370px)">
            <template slot-scope="scope">
              <div class="fileName">{{ scope.row.fileName }}</div>
              <svg-icon v-if="scope.row.templateType && scope.row.templateType !== 0" :class="[
                  'templateMark',
                  cloudHomeI18n === 'en-us' ? 'templateMark_en' : '',
                ]" :icon-class="
                  cloudHomeI18n === 'en-us'
                    ? 'template_mark_en'
                    : 'template_mark'
                "></svg-icon>
            </template>
          </moo-table-column>
          <moo-table-column prop="ownerName" :label="$t('所有者#!!!#src/pages/CloudHome/components/List.vue_1')" width="150"></moo-table-column>
          <moo-table-column prop="operationTime" :label="$t('最近使用#!!!#src/pages/CloudHome/components/List.vue_1')" width="150">
            <template slot-scope="scope">
              {{ formatTime(scope.row.operationTime) }}
            </template>
          </moo-table-column>
          <!-- <moo-table-column prop="operationType" label="最近使用" width="150">
            <template slot-scope="scope">
              {{ getFileOperationType(scope.row.operationType) }}
            </template>
          </moo-table-column> -->
          <moo-table-column width="50">
            <template slot="header" slot-scope="scope">
              <svg-icon @click="refresh" iconClass="refresh" class="refresh-icon"></svg-icon>
            </template>
          </moo-table-column>
          <div class="empty" slot="empty">
            <svg-icon iconClass="cloud-empty" class="empty-icon"></svg-icon>
            <div>{{$t("暂无内容#!!!#src/pages/CloudHome/components/List.vue_1")}}</div>
          </div>
        </moo-table>
        <!-- 我的文档 -->
        <moo-table @row-click="handleClick" v-if="headerTitle == 2" :data="listData" style="width: 100%" height="100%">
          <moo-table-column prop="contentType" :label="$t('类型#!!!#src/pages/CloudHome/components/List.vue_2')" width="70">
            <template slot-scope="scope">
              <div class="file-icon-container" v-show="showSvgIcon(scope.row)">
                <svg-icon :iconClass="getFileIcon(scope.row)" class="file-icon"></svg-icon>
                <pcShortCut v-if="scope.row.shortcut === true" :class="[
                    'file-short-icon',
                    scope.row.type === '1' ? 'file-short-dir-icon' : '',
                  ]"></pcShortCut>
              </div>
              <div class="file-icon" v-show="!showSvgIcon(scope.row)" v-if="isPicture(scope.row.fileName)">
                <img @error="onImageError(scope.row)" @load="onImageLoad(scope.row)" class="file-image" :src="imgSrc(scope.row.fileId)">
              </div>
            </template>
          </moo-table-column>
          <moo-table-column show-overflow-tooltip="" prop="fileName" :label="$t('名称#!!!#src/pages/CloudHome/components/List.vue_2')" width="calc(100% - 390px)">
            <template slot-scope="scope">
              <div class="fileName">{{ scope.row.fileName }}</div>
              <svg-icon v-if="scope.row.templateType && scope.row.templateType !== 0" :class="[
                  'templateMark',
                  cloudHomeI18n === 'en-us' ? 'templateMark_en' : '',
                ]" :icon-class="
                  cloudHomeI18n === 'en-us'
                    ? 'template_mark_en'
                    : 'template_mark'
                "></svg-icon>
            </template>
          </moo-table-column>
          <moo-table-column prop="operationTime" :label="$t('最近使用#!!!#src/pages/CloudHome/components/List.vue_2')" width="150">
            <template slot-scope="scope">
              {{ formatTime(scope.row.operationTime) }}
            </template>
          </moo-table-column>
          <moo-table-column prop="size" :label="$t('大小#!!!#src/pages/CloudHome/components/List.vue_1')" width="150">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row) }}
            </template>
          </moo-table-column>
          <moo-table-column width="50">
            <template slot="header" slot-scope="scope">
              <svg-icon @click="refresh" iconClass="refresh" class="refresh-icon"></svg-icon>
            </template>
          </moo-table-column>
          <div class="empty" slot="empty">
            <svg-icon iconClass="cloud-empty" class="empty-icon"></svg-icon>
            <div>{{$t("暂无内容#!!!#src/pages/CloudHome/components/List.vue_2")}}</div>
          </div>
        </moo-table>
        <!-- 知识库列表 -->
        <moo-table @cell-click="handleOpenWiki" v-if="headerTitle == 3" :data="listData" style="width: 100%" height="100%">
          <moo-table-column prop="contentType" :label="$t('知识库名称#!!!#src/pages/CloudHome/components/List.vue_1')" width="calc(100% - 350px)">
            <template slot-scope="scope">
              <div class="wiki-space">
                <img v-if="scope.row?.wikiSpaceIcon?.imageUrl" class="file-icon wiki-file-icon" :src="scope.row?.wikiSpaceIcon?.imageUrl" alt="">
                <svg-icon v-else iconClass="cloud-wiki" class="file-icon"></svg-icon>
                <div class="wiki-name">
                  <div class="wiki-title">
                    <span class="wiki-title-info">{{
                      scope.row.wikiSpaceName
                    }}</span>
                    <span v-show="scope.row.visibleScope == 'ORGANIZATION'" class="open-tag">{{$t("公开#!!!#src/pages/CloudHome/components/List.vue_1")}}</span>
                  </div>
                  <div class="wiki-desc">{{ scope.row.wikiSpaceDesc }}</div>
                </div>
              </div>
            </template>
          </moo-table-column>
          <!-- <moo-table-column show-overflow-tooltip prop="wikiSpaceName" label="知识库名称" width="calc(100% - 470px)">
            <template slot-scope="scope">
              
            </template>
          </moo-table-column> -->
          <moo-table-column prop="top" width="50" label="">
            <template slot-scope="scope">
              <moo-popover :close-delay="0" popper-class="wiki-top-popper" placement="top" trigger="hover" :content="scope.row.star
  ? $t('取消置顶#!!!#src/pages/CloudHome/components/List.vue_1')
  : $t('置顶#!!!#src/pages/CloudHome/components/List.vue_1')">
                <div slot="reference" class="wiki-top">
                  <svg-icon slot="reference" :iconClass="
                      scope.row.star ? 'cloud-wiki-untop' : 'cloud-wiki-top'
                    " class="top-icon"></svg-icon>
                </div>
              </moo-popover>
            </template>
          </moo-table-column>
          <moo-table-column prop="creator" :label="$t('所有者#!!!#src/pages/CloudHome/components/List.vue_2')" width="150"></moo-table-column>
          <moo-table-column prop="createTime" :label="$t('最近访问#!!!#src/pages/CloudHome/components/List.vue_1')" width="200">
            <!-- <template slot="header" slot-scope="scope">
              <moo-popover v-model="sortVisible" :close-delay="0" popper-class="wiki-sort-popper"
                placement="bottom-start" trigger="click">
                <div class="wiki-sort">
                  <div class="sort-item">最近访问<svg-icon slot="reference" iconClass="cloud-sort-check"
                      class="check-icon"></svg-icon></div>
                  <div class="sort-item">最近更新<svg-icon slot="reference" iconClass="cloud-sort-check"
                      class="check-icon"></svg-icon></div>
                </div>
                <div slot="reference" class="wiki-sort-inner">
                  最近更新 <svg-icon slot="reference" iconClass="cloud-wiki-sort" :class="{
                    'sort-icon': true,
                    'sort-icon-down': !sortVisible
                  }"></svg-icon>
                </div>
              </moo-popover>
            </template> -->
            <template slot-scope="scope">
              {{ formatWikiTime(scope.row.operationTime) }}
            </template>
          </moo-table-column>
          <moo-table-column width="50">
            <template slot="header" slot-scope="scope">
              <svg-icon @click="refresh" iconClass="refresh" class="refresh-icon"></svg-icon>
            </template>
          </moo-table-column>
          <div class="empty" slot="empty">
            <svg-icon iconClass="cloud-empty" class="empty-icon"></svg-icon>
            <div>{{$t("暂无内容#!!!#src/pages/CloudHome/components/List.vue_3")}}</div>
          </div>
        </moo-table>
        <!-- 收藏列表-->
        <moo-table @row-click="handleClick" v-if="headerTitle == 5" :data="listData" style="width: 100%" height="100%">
          <moo-table-column prop="contentType" :label="$t('类型#!!!#src/pages/CloudHome/components/List.vue_3')" width="70">
            <template slot-scope="scope">
              <div class="file-icon-container" v-show="showSvgIcon(scope.row)">
                <svg-icon :iconClass="getFileIcon(scope.row)" class="file-icon"></svg-icon>
                <pcShortCut v-if="scope.row.shortcut === true" :class="[
                    'file-short-icon',
                    scope.row.type === '1' ? 'file-short-dir-icon' : '',
                  ]"></pcShortCut>
              </div>
              <div class="file-icon" v-show="!showSvgIcon(scope.row)" v-if="isPicture(scope.row.fileName)">
                <img class="file-image" @error="onImageError(scope.row)" @load="onImageLoad(scope.row)" :src="imgSrc(scope.row.fileId)">
              </div>
            </template>
          </moo-table-column>
          <moo-table-column show-overflow-tooltip="" prop="fileName" :label="$t('名称#!!!#src/pages/CloudHome/components/List.vue_3')" width="calc(100% - 370px)">
            <template slot-scope="scope">
              <div class="fileName">{{ scope.row.fileName }}</div>
              <svg-icon v-if="scope.row.templateType  && scope.row.templateType !== 0" :class="[
                  'templateMark',
                  cloudHomeI18n === 'en-us' ? 'templateMark_en' : '',
                ]" :icon-class="
                  cloudHomeI18n === 'en-us'
                    ? 'template_mark_en'
                    : 'template_mark'
                "></svg-icon>
            </template>
          </moo-table-column>
          <moo-table-column prop="ownerName" :label="$t('所有者#!!!#src/pages/CloudHome/components/List.vue_3')" width="150">
            <template slot-scope="scope">
              {{ scope.row.creatorInfo.userName }}
            </template>
          </moo-table-column>
          <moo-table-column prop="starTime" :label="$t('收藏时间#!!!#src/pages/CloudHome/components/List.vue_1')" width="150">
            <template slot-scope="scope">
              {{ formatTime(scope.row.starTime) }}
            </template>
          </moo-table-column>
          <!-- <moo-table-column prop="operationType" label="最近使用" width="150">
            <template slot-scope="scope">
              {{ getFileOperationType(scope.row.operationType) }}
            </template>
          </moo-table-column> -->
          <moo-table-column width="50">
            <template slot="header" slot-scope="scope">
              <svg-icon @click="refresh" iconClass="refresh" class="refresh-icon"></svg-icon>
            </template>
          </moo-table-column>
          <div class="empty" slot="empty">
            <svg-icon iconClass="cloud-empty" class="empty-icon"></svg-icon>
            <div>{{$t("暂无内容#!!!#src/pages/CloudHome/components/List.vue_4")}}</div>
          </div>
        </moo-table>
        <UploadDialog :isFolder="false" :fileUploader="fileUploader" ref="uploadDialog" @open-item="openItem"></UploadDialog>
      </div>
    </div>
    <div v-if="showTemplate" id="toca_wiki_template_container" class="toca_wiki_template_container"></div>
    <!-- 文件夹上传 -->
    <input v-if="refreshFolderUpload" :style="{ display: 'none' }" ref="folderInput" type="file" @change="handleFolderUpload" webkitdirectory="" multiple="">
    <!-- 文件上传 -->
    <input v-if="refreshFileUpload" :style="{ display: 'none' }" ref="fileInput" type="file" :accept="
        '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'
      " @change="handleFileUpload" multiple="">
    <!-- 重命名检查 -->
    <CheckDialog @folderUploadChange="folderUploadChange" @fileUploadChange="fileUploadChange" ref="check"></CheckDialog>
    <!-- 上传文件夹确认文件格式弹窗 -->
     <PreCheckFolderUploadDialog @handlUpload="handlePreCheckUpload" ref="preCheck"></PreCheckFolderUploadDialog>
  </div>
</template>

<script>
import Header from "./Header.vue";
import CreatePopper from "./CreatePopper.vue";
import UploadPopper from "./UploadEntrance.vue";
import StarList from "./starList.vue";
import {
  createFile,
  getRecentFile,
  getMyFile,
  getWikiList,
  starWiki,
  getStarList,
  unStarWiki,
  fetchStarWikiList,
  checkFileName } from
"@/api/cloudHome";
import { mapState, mapActions } from "vuex";
import { fileImgName } from "@/utils/avatar";
import moment from "moment";
import { debounce } from "@/utils/lodash";
import { useI18n, intl } from "tci18n-vue2";
const { lang } = useI18n();
import TemplateEntrance from "./TemplateEntrance.vue";
import "@toca/toca-wiki-template/dist/style.css";
import { TocaWikiTemplate } from "@toca/toca-wiki-template";
import cookies from "js-cookie";
import { updateSaviorData, setSaviorConfigure } from "../utils/savior";
import pcShortCut from "../assets/pcShortCut.vue";
import FileUploader from "../../../utils/mpaUploader/index.js";
import UploadDialog from "./UploadDialog.vue";
import CheckDialog from "./CheckDialog.vue";
import PreCheckFolderUploadDialog from "./PreCheckFolderUploadDialog.vue";

export default {
  name: "List",
  components: {
    Header,
    CreatePopper,
    StarList,
    TemplateEntrance,
    pcShortCut,
    UploadDialog,
    CheckDialog,
    UploadPopper,
    PreCheckFolderUploadDialog
  },
  data() {
    return {
      iconStatus: [],
      listData: [],
      page: 0,
      totalPage: 0,
      lastScrollTop: 0,
      listDom: null,
      sortType: "",
      sortVisible: false,
      showTemplate: false,
      tocaWikiTemplate: null,
      refreshFileUpload: true,
      refreshFolderUpload: true,
      fileUploader: null,
      tabTitle: intl.$t("最近使用#!!!#src/pages/CloudHome/components/List.vue_3")
    };
  },
  created() {},
  mounted() {
    // 获取表格对象
    let dom = document.querySelector(".moo-table__body-wrapper");
    this.listDom = dom;
    dom.addEventListener("scroll", this.scrollLoad);
    this.handleTabLoad();
    this.fetchWikiStarList();
    this.initFileUploader();
  },
  beforeDestroy() {
    this.listDom.removeEventListener("scroll", this.scrollLoad);
  },
  methods: {
    ...mapActions({
      setHeaderTitle: "setHeaderTitle",
      setStarWikiList: "setStarWikiList",
      newTasks: "newTasks",
      changeTaskStatus: "changeTaskStatus",
      removeTasks: "removeTasks",
      changeUploadSpeed: "changeUploadSpeed",
      changeUploadProgress: "changeUploadProgress"
    }),
    gotoSearch() {
      this.$emit("gotoSearch");
    },
    gotoAISearch() {
      this.$emit("gotoAISearch");
    },
    handleSortType(val) {
      this.sortType = val;
    },
    handleOpenWiki: debounce(async function (row, column, cell, event) {
      if (column.property == "top") {
        console.log("置顶");
        const messageInfo = row.star ? intl.$t("取消置顶成功#!!!#src/pages/CloudHome/components/List.vue_1") : intl.$t("置顶成功#!!!#src/pages/CloudHome/components/List.vue_1");
        const messageInfoError = row.star ? intl.$t("取消置顶失败#!!!#src/pages/CloudHome/components/List.vue_1") : intl.$t("置顶失败#!!!#src/pages/CloudHome/components/List.vue_1");
        try {
          let res;
          if (row.star) {
            res = await unStarWiki(row.wikiSpaceId);
          } else {
            res = await starWiki(row.wikiSpaceId);
          }
          if (res.code == 200) {
            this.$message.success(messageInfo);
          } else {
            this.$message.error(messageInfoError);
          }
          this.fetchWikiStarList();
          // this.refresh()
          this.listData.find(
            (item) => item.wikiSpaceId == row.wikiSpaceId
          ).star = !row.star;
        } catch {
          this.$message.error(messageInfoError);
        }
      } else {
        window.open(row.wikiSpaceUrl, "_blank");
      }
    }, 300),
    async fetchWikiStarList() {
      try {
        const res = await fetchStarWikiList({
          since: 0,
          size: 50
        });
        if (res.code == 200) {
          this.setStarWikiList(res.data.result);
        }
      } catch {}
    },
    scrollLoad: debounce(function (v) {
      const dom = this.listDom;
      const scrollDistance =
      this.listDom.scrollHeight - dom.scrollTop - dom.clientHeight;
      // 判断是否到底，可以加载下一页
      const st = dom.scrollTop;
      if (st > this.lastScrollTop) {
        // 向下滚动的逻辑
        if (scrollDistance <= 1) {
          // 判断是否全部加载完成
          if (this.page >= this.totalPage) {

            // this.$message.warning("已经见底了 ～");
          }if (this.page < this.totalPage) {
            //当前页数小于总页数就请求
            // 加载下一页方法
            this.getNextList(this.page);
          }
        }
      } else {

        // 向上滚动的逻辑
      }this.lastScrollTop = st <= 0 ? 0 : st;
    }, 300),
    onImageError(e) {
      console.log(e, "error");
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item) {
        item.value = -1;
        return;
      }
      this.iconStatus.push({
        key: e.fileId,
        value: -1
      });
    },
    onImageLoad(e) {
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item) {
        item.value = 1;
        return;
      }
      this.iconStatus.push({
        key: e.fileId,
        value: 1
      });
    },
    showSvgIcon(e) {
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item == null) return true;
      if (item.value !== 1) return true;
    },
    isPicture(name = "") {
      name = name?.trim();
      let index = name.lastIndexOf(".");
      if (index === -1 || index === name.length - 1) return false;
      const ext = name.substr(index + 1).toLowerCase();
      const pic =
      ext === "png" ||
      ext === "jpg" ||
      ext === "jpeg" ||
      ext === "gif" ||
      ext === "bmp" ||
      ext === "ico" ||
      ext === "heic" ||
      ext === "webp";
      return pic;
    },
    imgSrc(fileId) {
      const url = `http:${process.env.VUE_APP_INNERNET_URL}/file/thumbnail/${fileId}`;
      console.log(url, "url");
      return url;
    },
    handleTabLoad() {
      const hash = this.$route.hash;
      if (hash.includes("my")) {
        this.setHeaderTitle(2);
      } else if (hash.includes("wiki")) {
        this.setHeaderTitle(3);
      } else if (hash.includes("star")) {
        this.setHeaderTitle(5);
      } else {
        this.getNextList(this.page);
      }
    },
    handleClick(row, column, event) {
      window.open(row.fileUrl, "_blank");
    },
    formatFileSize(item, decimals = 2) {
      if (item.type !== "0") return "-";
      const bytes = item.size;
      if (typeof bytes === "string") {
        bytes = parseInt(bytes);
      }
      if (bytes === 0) return "0 B";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "K", "M", "G", "T", "P", "E", "Z", "Y"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    getFileOperationType(t) {
      switch (t) {
        case "0":
          return intl.$t("上传#!!!#src/pages/CloudHome/components/List.vue_1");
        case "1":
          return intl.$t("下载#!!!#src/pages/CloudHome/components/List.vue_1");
        case "2":
          return intl.$t("打开#!!!#src/pages/CloudHome/components/List.vue_1");
        case "3":
          return intl.$t("编辑#!!!#src/pages/CloudHome/components/List.vue_1");
        case "4":
          return intl.$t("共享给我#!!!#src/pages/CloudHome/components/List.vue_1");
        case "5":
          return intl.$t("我共享的#!!!#src/pages/CloudHome/components/List.vue_1");
        default:
          return intl.$t("浏览#!!!#src/pages/CloudHome/components/List.vue_1");
      }
    },
    formatWikiTime(val) {
      const locale = this.cloudHomeI18n || localStorage.getItem("tci18nLocale") || navigatorLang[navigator.language] || "zh-cn";
      let formatStr = intl.$t("YYYY年MM月DD日 HH:mm#!!!#src/pages/CloudHome/components/List.vue_1");
      if (locale !== 'zh-cn') {
        formatStr = "YYYY-MM-DD HH:mm";
      }
      return val !== undefined && val !== null ? moment(new Date(val)).format(formatStr) : "-";
    },
    formatTime(val) {
      if (val === undefined || val === null) {
        return '-';
      }
      if (typeof val === "string") {
        val = parseInt(val);
      }
      const currentDate = new Date(val);
      const current = currentDate.getTime();
      const today = new Date(new Date().toLocaleDateString()).getTime();
      const yesterday = today - 3600 * 1000 * 24;
      var now = new Date();
      const year = now.getFullYear();
      const dt = moment(currentDate);
      const currentYear = dt.year();

      if (current > today) {
        if (lang.includes("en")) {
          let todayTime = this.formatTimeOfTodayOrYesterday(dt, intl.$t("今天#!!!#src/pages/CloudHome/components/List.vue_1"));
          todayTime = todayTime.replace("今天", "Today");
          return todayTime;
        } else {
          return this.formatTimeOfTodayOrYesterday(dt, intl.$t("今天#!!!#src/pages/CloudHome/components/List.vue_2"));
        }
      } else if (current > yesterday) {
        if (lang.includes("en")) {
          let yesterdayTime = this.formatTimeOfTodayOrYesterday(dt, intl.$t("昨天#!!!#src/pages/CloudHome/components/List.vue_1"));
          yesterdayTime = yesterdayTime.replace("昨天", "Yesterday");
          return yesterdayTime;
        } else {
          return this.formatTimeOfTodayOrYesterday(dt, intl.$t("昨天#!!!#src/pages/CloudHome/components/List.vue_2"));
        }
      } else if (year !== currentYear) {
        return dt.format(intl.$t("YYYY年MM月DD日#!!!#src/pages/CloudHome/components/List.vue_1"));
      } else {
        return dt.format(intl.$t("MM月DD日 HH:mm#!!!#src/pages/CloudHome/components/List.vue_1"));
      }
    },
    formatTimeOfTodayOrYesterday(dt, day) {
      return dt.format(`${day} HH:mm`);
    },
    getFileIcon(item) {
      const { fileName, type, contentType = "" } = item;
      if (contentType == "DOCUMENT") {
        return "cloud-online-doc";
      }
      if (type !== "0") return "cloud-folder";
      const name = fileName.trim();
      const index = name.lastIndexOf(".");
      if (index === -1) return "cloud-other";
      const ext = name.
      substr(index).
      replace(".", "").
      toLowerCase();
      return fileImgName(ext);
    },
    fileAvatar(item) {
      if (item.fileExtension) {
        return fileImgName(item.fileExtension);
      }
      return fileImgName(item.contentType);
    },
    async handleCreate(type, fileId = "") {
      this.gotoTemplateLib([type], true);
    },
    async getNextList(since, size) {
      console.log("加载下一页");
      const ownId = this.spaceId + "_" + this.userId + "_doc";
      try {
        if (this.headerTitle == 1) {
          const res = await getRecentFile({
            since,
            size: 100
          });
          this.totalPage = res.data.pager.total;
          const newListData = [...this.listData, ...res.data.result];
          this.page += res.data.result.length; //当前页数自增
          this.listData = newListData;
        } else if (this.headerTitle == 2) {
          const res = await getMyFile({
            since,
            size: 100,
            parentId: ownId
          });
          this.totalPage = res.data.pager.total;
          const filterData = res.data.result.filter(
            (item) => item.fileId != this.spaceId + "_" + this.userId
          );
          //   console.log(filterData, "222222");
          const newListData = [...this.listData, ...filterData];
          this.page += res.data.result.length; //当前页数自增
          this.listData = newListData;
        } else if (this.headerTitle == 5) {
          const res = await getStarList({
            since,
            size: 100
          });
          this.totalPage = res.data.pager.total;
          const newListData = [...this.listData, ...res.data.result];
          this.page += res.data.result.length; //当前页数自增
          this.listData = newListData;
        } else {
          const res = await getWikiList({
            since,
            size: 100
          });
          this.totalPage = res.data.pager.total;
          const newListData = [...this.listData, ...res.data.result];
          this.page += res.data.result.length; //当前页数自增
          this.listData = newListData;
        }
      } catch {}
    },
    refresh: debounce(async function (type) {
      const handleRefresh = () => {
        // 新建刷新列表
        this.listData = [];
        this.page = 0;
        this.totalPage = 0;
        this.getNextList(0);
      };
      if (this.headerTitle == 1 && type == "lazy") {
        setTimeout(() => {
          console.log("刷新列表++");
          handleRefresh();
        }, 2000);
      } else {
        console.log("刷新列表--");
        handleRefresh();
      }
    }, 300),
    async gotoTemplateLib(createType, isCreate = false) {
      this.showTemplate = true;
      let that = this;
      this.$nextTick(() => {
        const cookie = {
          token: cookies.get("token"),
          spaceId: cookies.get("spaceId"),
          userId: cookies.get("userId"),
          deviceId: cookies.get("deviceId"),
          memberUniqueId: cookies.get("memberUniqueId") || this.memberId,
          memberId: cookies.get("memberId") || this.memberId
        };
        let env = process.env.VUE_APP_STATIC_NODE_ENV;
        // if (env === "qa") env = "development";

        const param = {
          env: env,
          cookies: cookie,
          isCreate: isCreate,
          isPCMode: false,
          //   createType: createType,
          currentCreateType: createType[0],
          createType: ["DOCUMENT", "EXCEL", "PPT", "WORD"],
          savior: {
            setSaviorConfigure: setSaviorConfigure,
            updateSaviorData: updateSaviorData
          },
          onCreateEmptyTemplate: () => {
            const ownId = this.spaceId + "_" + this.userId + "_doc";
            createFile({
              templateFileId: "",
              newFileType: createType[0],
              parentId: ownId,
              productType: "CLOUD_DOCUMENT"
            }).
            then((res) => {
              const { code, data } = res;
              if (code === 200) {
                if (code === 200 && data.fileId) {
                  window.open(
                    `https:${process.env.VUE_APP_BASE_URL}/cloud?fid=${data?.fileId}&type=fileCreate` + (
                    lang === "en-us" ? "&lang=en-us" : ""),
                    "_blank"
                  );
                  that.refresh("lazy");
                }
              }
            }).
            catch((err) => {});
          },
          onCloseTemplate: () => {
            that.showTemplate = false;
          },
          onUseTemplate: (template) => {
            updateSaviorData({
              eventtype: "click",
              category: "cloud_document",
              label: "new_fromTemplate",
              eventid: "Template_opreation",
              value: {
                fid: template.fileId
              }
            });

            const ownId = this.spaceId + "_" + this.userId + "_doc";
            createFile({
              templateFileId: template.fileId,
              newFileType: template.contentType,
              parentId: ownId,
              productType: "CLOUD_DOCUMENT"
            }).
            then((res) => {
              const { code, data } = res;
              if (code === 200) {
                if (code === 200 && data.fileId) {
                  window.open(
                    `https:${process.env.VUE_APP_BASE_URL}/cloud?fid=${data?.fileId}&type=fileCreate` + (
                    lang === "en-us" ? "&lang=en-us" : ""),
                    "_blank"
                  );
                  that.refresh("lazy");
                }
              }
            }).
            catch((err) => {});
          },
          locale:
          this.cloudHomeI18n ||
          localStorage.getItem("tci18nLocale") ||
          navigatorLang[navigator.language] ||
          "zh-cn"
        };

        this.tocaWikiTemplate = new TocaWikiTemplate(
          "#toca_wiki_template_container",
          cookie,
          param
        );
      });
    },
    initFileUploader() {
      // 初始化上传组件
      const options = {
        domain: process.env.VUE_APP_UPLOAD, // 接口域名
        debug:
        process.env.VUE_APP_STATIC_NODE_ENV !== "production" ? true : false, // 是否调试模式, 将打印大量信息
        maxWorkers: 1, // 最大同时允许几个任务
        headers: {
          deviceType: "1",
          spaceId: cookies.get("spaceId"),
          userId: cookies.get("userId"),
          token: cookies.get("token"),
          deviceId: cookies.get("deviceId")
        }
      };
      const fileUploaderInit = new FileUploader(options);
      this.fileUploader = fileUploaderInit;
      // 上传事件监听
      fileUploaderInit.on("new-tasks", (tasks) => {
        this.newTasks(tasks);
        this.$refs.uploadDialog.showUploadDialog(true);
      });

      fileUploaderInit.on("remove-task", (tid) => {
        this.removeTasks(tid);
      });

      fileUploaderInit.on("task-status-change", (tid, status) => {
        this.changeTaskStatus({ tid, status });
      });

      fileUploaderInit.on("upload-speed", (e) => {
        console.log('--------------------------speed:', e);
        this.changeUploadSpeed(e);
      });

      fileUploaderInit.on("upload-progress", (e) => {
        console.log('--------------------------progress:', e);
        this.changeUploadProgress(e);
      });

      fileUploaderInit.on("complete", (task) => {
        // 文件上传完成
        this.refresh();
        this.$refs.uploadDialog.showUploadDialog(true);
      });
    },
    openItem(item) {
      this.$router.push({
        name: "home",
        query: {
          fid: item.fileId,
          // rootId 在目录切换过程中，都为固定值，因此新增一个参数用于防止目录切换过程中页面刷新时，rootId获取不到的问题
          rid: this.rootId,
          ...item
        }
      });
    },
    handlePreCheckUpload() {
      this.$refs.folderInput.click();
    },
    handleUpload(type) {
      switch (type) {
        case "UPLOADFILE":
          this.$refs.fileInput.click();
          break;
        case "UPLOADFOLDER":
          this.$refs.preCheck.handleCheckDialog(true);
          break;
        default:
          break;
      }
    },
    async handleFolderUpload(event) {
      const target = event.target;
      let files = Array.from(target.files);
      const folderName = files[0].webkitRelativePath.split("/")[0];
      const suffix = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".pdf"];
      files = files.filter((file) => {
        const fileName = file.name.toLowerCase();
        return suffix.some((s) => fileName.endsWith(s));
      });
      const { newFileName = "", type } = await this.checkUploadFile(
        "folder",
        folderName
      );
      const ownId = this.spaceId + "_" + this.userId + "_doc";
      const pid = this.isFolder ? this.fileId : ownId;
      if (newFileName) {
        this.$refs.check.handleCheckDialog(true, {
          fileName: folderName,
          newfolderName: newFileName,
          type,
          files,
          pid
        });
      } else {
        const task = this.fileUploader.addFolder(files, pid);
      }
      this.refreshFolderUpload = false;
      setTimeout(() => {
        this.refreshFolderUpload = true;
      }, 200);
    },
    folderUploadChange(files, pid, type) {
      const task = this.fileUploader.addFolder(files, pid, type);
    },
    async checkUploadFile(type, fileName) {
      let parentId = this.spaceId + "_" + this.userId + "_doc";
      const {
        code,
        data: { nameList }
      } = await checkFileName({
        parentId,
        nameList: [{ fileName, type: type == "file" ? "0" : "1" }]
      });
      return nameList[0] || {};
    },
    async handleFileUpload(event) {
      const target = event.target;
      let files = Array.from(target.files);
      const fileName = files[0].name;
      const suffix = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".pdf"];
      files = files.filter((file) => {
        const tmpFileName = file.name.toLowerCase();
        return suffix.some((s) => tmpFileName.endsWith(s));
      });
      const { newFileName = "", type } = await this.checkUploadFile(
        "file",
        fileName
      );
      const ownId = this.spaceId + "_" + this.userId + "_doc";
      const pid = this.isFolder ? this.fileId : ownId;
      if (newFileName) {
        this.$refs.check.handleCheckDialog(true, {
          fileName,
          type,
          files,
          pid
        });
      } else {
        const task = this.fileUploader.addFiles(files, pid);
      }
      this.refreshFileUpload = false;
      setTimeout(() => {
        this.refreshFileUpload = true;
      }, 200);
    },
    fileUploadChange(files, pid, type) {
      const task = this.fileUploader.addFiles(files, pid, type);
    }
  },
  watch: {
    headerTitle(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listData = [];
        this.refresh();
      }
    }
  },
  computed: {
    ...mapState({
      spaceId: (state) => state.spaceId,
      userId: (state) => state.userId,
      memberId: (state) => state.currentUserInfo.id,
      collapse: (state) => state.collapse,
      headerTitle: (state) => state.headerTitle,
      starWikiList: (state) => state.starWikiList,
      cloudHomeI18n: (state) => state.cloudHomeI18n
    }),
    tableClass() {
      let tableCustom = "";
      if (this.headerTitle == 1) {
        tableCustom = "table-recent";
      }
      if (this.headerTitle == 2) {
        tableCustom = "table-my";
      }
      if (this.headerTitle == 3 || this.headerTitle == 5) {
        tableCustom = "table-wiki";
      }
      return "table-content " + tableCustom;
    }
  }
};
</script>

<style lang="scss">
.toca_wiki_template_container {
  z-index: 999;
  position: fixed;
  width: 100%;
  height: 100%;
}

.wiki-sort-popper {
  min-width: 122px !important;
  padding: 4px 8px 8px 8px !important;
  /* margin: 0 !important; */
  margin-bottom: 5px !important;
  line-height: 36px !important;
  text-align: center !important;
  /* height: 36px !important; */
  background: #ffffff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  box-sizing: border-box;

  .wiki-sort {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;

    .sort-item {
      width: 114px;
      height: 32px;
      border-radius: 8px;
      font-weight: 400;
      font-size: 14px;
      color: #222329;
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 8px;
      box-sizing: border-box;

      .check-icon {
        width: 12px;
        height: 12px;
      }

      &:hover {
        background: #f4f6f9;
      }
    }
  }

  .popper__arrow {
    display: none !important;
  }
}

.wiki-sort-inner {
  .sort-icon {
    width: 10px;
    height: 10px;
  }

  .sort-icon-down {
    transform: scaleX(-1) rotate(180deg);
  }
}

.wiki-top-popper {
  min-width: 36px !important;
  padding: 0 8px !important;
  /* margin: 0 !important; */
  margin-bottom: 5px !important;
  line-height: 36px !important;
  text-align: center !important;
  height: 36px !important;
  background: #ffffff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;

  .popper__arrow {
    display: none !important;
  }
}

.wiki-top {
  width: 24px;
  height: 24px;
  display: none;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: #e7eaee;
  }
}

.top-icon {
  user-select: none;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.moo-tooltip {
  display: flex;
  flex-direction: row;
  align-items: center;

  .fileName {
    font-weight: 400;
    line-height: 20px;
    font-size: 14px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .templateMark_en {
    width: 52px !important;
  }
  .templateMark {
    margin: 0px 4px;
    width: 28px;
    height: 16px;
    overflow: unset;
  }
}

.list {
  flex: 1;
  min-width: calc(100% - 210px);
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding-bottom: 20x;
  box-sizing: border-box;

  .list-content {
    padding: 8px 20px;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .tab-title {
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #121317;
      margin: 0 0 14px 0;
    }

    .toolbar {
      display: flex;
      flex-direction: row;
      gap: 15px;
      height: 60px;
      margin-bottom: 22px;
    }

    .table-recent {
      height: calc(100% - 120px) !important;
    }

    .table-my {
      height: calc(100% - 82px) !important;
    }

    .table-wiki {
      height: 100% !important;

      ::-webkit-scrollbar {
        display: none;
      }

      .moo-table__body-wrapper {
      }
    }

    .table-content {
      flex-shrink: 0;
      cursor: pointer;
      box-sizing: border-box;

      .moo-table::before {
        display: none;
      }

      .moo-table th {
        background: #fafafa;
        font-weight: 400;
        color: #646573;
      }

      .moo-table {
        .cell {
          padding-left: 20px;
          padding-right: 0;
        }
      }

      .moo-table tr:hover {
        background: #f4f6f9;

        .wiki-top {
          display: flex;
        }
      }

      .moo-table td {
        font-weight: 400;
        color: #222329;
      }

      .moo-table .cell {
        user-select: none;
      }

      .file-icon-container {
        position: relative;
        .file-short-dir-icon {
          left: 1px !important;
          bottom: 3px !important;
        }

        .file-short-icon {
          position: absolute;
          left: 1px;
          bottom: 3px;
        }
      }

      .file-icon {
        width: 38px;
        height: 38px;
        flex-shrink: 0;

        .file-image {
          overflow: hidden;
          max-width: 38px;
          max-height: 38px;
        }
      }

      .wiki-file-icon {
        border-radius: 6px;
      }

      .refresh-icon {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
      }

      .empty {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.3);
        display: flex;
        flex-flow: column;
        align-items: center;
        width: 100%;
        line-height: normal;

        .empty-icon {
          font-size: 48px;
        }
      }

      .wiki-name {
        overflow: hidden;
        margin-left: 16px;
        display: flex;
        flex-flow: column;
        width: 100%;
        height: 36px;
        justify-content: center;
        line-height: normal !important;

        .wiki-title {
          display: flex;
          flex-flow: row;
          align-items: center;

          .wiki-title-info {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .wiki-desc {
          font-size: 12px;
          color: #a5a7b3;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .open-tag {
          margin-left: 8px;
          padding: 0 4px;
          height: 18px;
          text-align: center;
          line-height: 18px;
          background: #eef0ff;
          border-radius: 4px;
          font-weight: 500;
          font-size: 10px;
          color: #5c70ff;
        }
      }

      .wiki-space {
        display: flex;
        flex-flow: row;
        align-items: center;
      }
    }
  }

  .list-content-scroll {
    overflow-y: auto;
  }
}

/* 修改滚动条的宽度 */
::-webkit-scrollbar {
  width: 4px;
  border-radius: 8px;
}

/* 修改滚动条轨道的样式 */
/* ::-webkit-scrollbar-track {
    background: #f1f1f1;
} */

/* 修改滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
  background: #d5d8da;
  border-radius: 8px;
}

/* 当鼠标悬停在滚动条滑块上时，修改滑块的样式 */
/* ::-webkit-scrollbar-thumb:hover {
    background: #090909;
} */
</style>
